import { render, staticRenderFns } from "./EducationInstitutions.vue?vue&type=template&id=4d1d4168"
import script from "./EducationInstitutions.vue?vue&type=script&lang=js"
export * from "./EducationInstitutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports